import { INavigationContext } from 'framework/context/INavigationContext';
import React from 'react';
import { CustomerAccountDetailTabType } from '../detail/CustomerAccountDetailTabType';

export const NavigationContext = React.createContext<INavigationContext<CustomerAccountDetailTabType>>(undefined as any);
